import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import "../../styling/sidebar.css";
import "../../styling/expensepop.css";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { CircularProgress } from "@material-ui/core";
import Box from '@mui/material/Box';
import Modal from "react-bootstrap/Modal";
import GetUser from "../../services/get-user";
import { makeStyles } from "@material-ui/core";
import { toast } from "react-toastify";
import { isArray } from "lodash";
import moment from "moment";

const user = GetUser();
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface CsvWithAdvanceOptionProps {
  csvFileRecords: any[],
  openModal:boolean,
  setOpenModal:(any) => void,
  stream:any,
  setReloadAPI:(any) => void,
  closeExpenseModal?:(any) => void;
}

const CsvWithAdvanceOption: React.FC<CsvWithAdvanceOptionProps> = ({
  csvFileRecords,
  openModal,
  setOpenModal,
  stream,
  setReloadAPI,
  closeExpenseModal
}) => {
  console.log("csvFileRecords",csvFileRecords)
  const [csvObjestKeys, setCsvObjectKeys] = useState({});
  const [payloadColumn, setPayloadColumn] = useState<string[]>([]);
  const advancedFormField = ['name', 'amount', 'date', 'category', 'site', 'note']
  const [loading, setLoading] = useState(false);
  const [isFileUploaded,setIsUploadedFile]=useState(false)
  const useStyles = makeStyles({
    selected: {
      border: "1px solid green !impoortant",
      color: "#48b7a7 !important",
    },
  });

  useEffect(() => {
    if (csvFileRecords?.length && isArray(csvFileRecords[0])) {
      var data = {};
      csvFileRecords[0].forEach((value) => {
        data[value === "purchased from" ? "site" : ""] = "";
      });
      setCsvObjectKeys(data);
    }
  }, [csvFileRecords]);

  const handleChange = (event) => {
    !payloadColumn.includes(event.target.name) &&
      setPayloadColumn([...payloadColumn, event.target.name]);
    let copyObj = { ...csvObjestKeys };
    copyObj[event.target.name] = event.target.value.trim();
    setCsvObjectKeys(copyObj);
  };

  const getCsvObject = (newValueIndex: any) => {
    let data = {};
    csvFileRecords[0].forEach((value, index) => {
      if (csvFileRecords[newValueIndex].length >= 2)
        data[value.trim() === "purchased from" ? "site" : value.trim()] =
          csvFileRecords[newValueIndex][index];
    });
    return data;
  };

  const handleImportCsv = () => {
    setLoading(true)
    var isValidated = true;
    let requestPayload :any[]= [],data;
    const indexOfSite = advancedFormField.indexOf('site'); 
    
    requestPayload.push(Object.values({...advancedFormField, [indexOfSite]:"purchased from"}))
    if (!payloadColumn.includes("name")) {
      isValidated = false;
      toast.error("name is required");
    } 
    if (!payloadColumn.includes("amount")) {
      isValidated = false;
      toast.error("amount is required");
    } 
    for (let i = 1; i <= csvFileRecords.length - 1; i++) {
      data = getCsvObject(i); 
      let result :any []= [];
      for (const key of advancedFormField) {
        if(!payloadColumn.includes(key)){ 
            key !== 'date' ? result.push('') : result.push(new Date());
        }
        else{
          if(key === "date"){
            if(!moment(data[csvObjestKeys["date"]]).isValid()){
              result.push(moment().format("MMM DD yyyy"))
            }
            else{
              const newDate = data[csvObjestKeys["date"]]         
              ? moment(data[csvObjestKeys["date"]]).format("MMM DD yyyy")
              : moment().format("MMM DD yyyy");
              result.push(newDate)
            }
          }
          else if(key === "amount") {
            const typeAmount = typeof data[csvObjestKeys["amount"]] 
            if(typeAmount === 'object'){
              isValidated = false;
              toast.error("amount should be number");
              break;
            }
            const amount = data[csvObjestKeys["amount"]] && 
                          (typeAmount === 'string' &&  data[csvObjestKeys["amount"]].startsWith("$"))? data[csvObjestKeys["amount"]].replaceAll(",","").split("$").join("").trim() : data[csvObjestKeys["amount"]];
            if(isNaN(amount) || !amount){
              isValidated = false;
              toast.error("amount should be number");
              break;
            }else{
              result.push(Number(amount))
            }
          }
          else{
            result.push(data[csvObjestKeys[key]]? data[csvObjestKeys[key]]:"")
           }
        }
      }
      if(!isValidated){
        break;
      }
      requestPayload.push(result)
    }

    if(!isValidated){
      setLoading(false);
    }

    const Timeout=setTimeout(() => {
      if(!isFileUploaded){
      toast.info(<p> Email your file to <a href="mailto:support@sotira.co">support@sotira.co </a>and we will upload it for you</p>)
    }
    else{
      setIsUploadedFile(true)
      clearTimeout(Timeout)
    }
    }, 20000);

    try {
      if (isValidated) {
        return axios
          .post(
            "https://sotira-back-test.herokuapp.com/expense/add_csv_expense",
            {
              userID: user.userID,
              incomeStream: stream + 1,
              expenses: requestPayload,
            }
          )
          .then((response) => {
            setIsUploadedFile(true)
            clearTimeout(Timeout)
            sessionStorage.setItem("option", "expense");
            setLoading(false);
            setOpenModal(false);
            closeExpenseModal && closeExpenseModal(false);
            setReloadAPI((prevState)=>!prevState)
          });
      }
    } catch (e: any) {
      alert(e.response.data);
      setIsUploadedFile(false)
      setLoading(false);
      setOpenModal(false);

    }
  };

  return (
    <>
      <Modal
        show={openModal}
        backdrop="static"
        keyboard={false}
        className="csv-modal"
      >
        <Modal.Header
          closeButton
          onClick={() => {
            setOpenModal(false);
          }}
        >
          <div >
          <div>
          <Modal.Title>Import CSV/Excel</Modal.Title>
          </div>
          <p >Match your column names to the columns that we provide</p>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-around flex-column">
            <div className="d-flex mx-4 my-2 justify-content-between">
              <div>Name</div>
              <div>
                <FormControl sx={{ width: 200 }} required defaultValue="name">
                  <InputLabel id="demo-simple-select-label">Name</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Name"
                    name="name"
                    onChange={handleChange}
                    className="h-50"
                  >
                    {csvFileRecords[0].map((item) => (
                      <MenuItem
                        value={item === "purchased from" ? "site" : item}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="d-flex mx-4 my-2 justify-content-between">
              <div>Amount</div>
              <div>
                <FormControl sx={{ width: 200 }} required defaultValue="amount">
                  <InputLabel id="demo-simple-select-label">Amount</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Amount"
                    name="amount"
                    onChange={handleChange}
                  >
                    {csvFileRecords[0].map((item) => (
                      <MenuItem
                        value={item === "purchased from" ? "site" : item}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="d-flex mx-4 my-3 justify-content-between">
              <div>Date</div>
              <div>
                <FormControl sx={{ width: 200 }} defaultValue={0}>
                  <InputLabel id="demo-simple-select-label">Date</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Date"
                    name="date"
                    onChange={handleChange}
                  >
                    <MenuItem value="None">None</MenuItem>
                    {csvFileRecords[0].map((item) => (
                      <MenuItem
                        value={item === "purchased from" ? "site" : item}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="d-flex mx-4 my-3 justify-content-between">
              <div>Purchased From</div>
              <div>
                <FormControl sx={{ width: 200 }} defaultValue={0}>
                  <InputLabel id="demo-simple-select-label">
                    Purchased From
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Purchased Form"
                    name="site"
                    onChange={handleChange}
                  >
                    <MenuItem value="None">None</MenuItem>
                    {csvFileRecords[0].map((item) => (
                      <MenuItem
                        value={item === "purchased from" ? "site" : item}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="d-flex mx-4 my-3 justify-content-between">
              <div>Category</div>
              <div>
                <FormControl sx={{ width: 200 }} defaultValue={0}>
                  <InputLabel id="demo-simple-select-label">
                    Category
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Category"
                    name="category"
                    onChange={handleChange}
                  >
                    <MenuItem value="None">None</MenuItem>
                    {csvFileRecords[0].map((item) => (
                      <MenuItem
                        value={item === "purchased from" ? "site" : item}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="d-flex mx-4 my-3 justify-content-between">
              <div>Note</div>
              <div>
                <FormControl sx={{ width: 200 }} defaultValue={0}>
                  <InputLabel id="demo-simple-select-label">Note</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Name"
                    name="note"
                    onChange={handleChange}
                  >
                    <MenuItem value="None">None</MenuItem>
                    {csvFileRecords[0].map((item) => (
                      <MenuItem
                        value={item === "purchased from" ? "site" : item}
                      >
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
        <Button className="import-csv-button" onClick={handleImportCsv}>
          {loading ?
            <><CircularProgress className="file-loader mr-3" /> Uploading </>
            : 'Import Csv/Excel'
          }
        </Button> 
     
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CsvWithAdvanceOption;
